<template>
  <div class="custom-select" :class="computedCustomSelectClass">
    <v-select @open="open" v-model="selectedCustomSelect" :clearable="false" :options="customSelectOptions"
              label="label" :reduce="option => option.customSelectId">
      <template #header>
        <p class="custom-select__label">{{ customSelectHeadline }}:</p>
      </template>
      <template #open-indicator="{ attributes }">
        <svg v-bind="attributes" xmlns="http://www.w3.org/2000/svg" fill="none" height="6" width="11"
             viewBox="0 0 11 6">
          <path d="M5.714 6 .765 0h9.898L5.714 6Z"/>
        </svg>
      </template>
    </v-select>
  </div>
</template>
<script>

import vSelect from 'vue-select' // https://vue-select.org
import 'vue-select/dist/vue-select.css'

export default {
  data: () => ({
    selectedCustomSelect: null,
    hasTriggeredClass: false,
    initialPageLoad: true
  }),
  props: {
    customSelectOptions: {
      type: Object,
      required: true
    },
    customSelectInitial: {
      type: Object,
      required: false
    },
    customSelectHeadline: {
      type: String,
      required: true
    },
    customSelectClass: {
      type: String,
      required: false
    }
  },
  watch: {
    selectedCustomSelect(newVal) {
      if (!this.initialPageLoad) {
        location.href = "#" + newVal;
      } else {
        this.initialPageLoad = false;
      }
    },
  },
  mounted() {
    if (this.customSelectInitial) {
      if (Object.keys(this.customSelectInitial).length > 0) {
        this.selectedCustomSelect = this.customSelectInitial.customSelectId;
      }
    } else {
      this.initialPageLoad = false;
    }
  },
  components: {
    'v-select': vSelect
  },
  computed: {
    computedCustomSelectClass() {
      let data = '';

      if (this.customSelectClass) {
        data += this.customSelectClass;
      }

      if (this.hasTriggeredClass) {
        if (data.length) {
          data += ' ';
        }

        data += 'custom-select--triggered';
      }

      return data;
    }
  },
  methods: {
    open() {
      this.hasTriggeredClass = true;
    }
  }
}
</script>
